<div class="input-area">
    <div #suggestionsBox class="suggestions-box" *ngIf="suggestionsBoxVisible">
        <div class="result-item-container"
             [ngClass]="{ 'selected': username === selected }"
             (mouseover)="onResultItemHover(username.name)"
             (click)="onResultItemClick(username.name)"
             *ngFor="let username of filteredUsernames;">
            <div class="result-item">
                {{ username.name }}
            </div>
        </div>
    </div>
    <textarea #messageInput
              class="input"
              (keyup)="onKeyUp($event)"
              (keydown)="onKeyDown($event)"
              (focus)="onFocus()"
              placeholder="Send a message"></textarea>

    <a (click)="sendMessage()" data-toggle="tooltip" title="Send" class="ml-auto send"><i class="fa fa-paper-plane-o" aria-hidden="true"></i></a>
    <!--<button  title="Send" placement="top" class="ml-auto send"><i class="fa fa-paper-plane-o" aria-hidden="true"></i></button>-->
</div>